import { render, staticRenderFns } from "./PsCalendarGridDay.vue?vue&type=template&id=3fb3ae32&scoped=true&"
import script from "./PsCalendarGridDay.vue?vue&type=script&lang=js&"
export * from "./PsCalendarGridDay.vue?vue&type=script&lang=js&"
import style0 from "./PsCalendarGridDay.vue?vue&type=style&index=0&id=3fb3ae32&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb3ae32",
  null
  
)

export default component.exports